import clsx from "clsx";
import styles from "./UsersAvatar.module.scss";
import { useOrgPhoto } from "../../lib/hooks/useOrgPhoto";

type Props = React.HTMLAttributes<HTMLDivElement> & {
  profileImg?: string;
  organizationId?: number | undefined;
  onClick?: () => void;
  className?: string;
  nameInitials: string;
};

export function UsersAvatar({
  profileImg,
  onClick,
  className,
  nameInitials,
  organizationId = undefined,
  ...props
}: Props) {
  const organizationImageUrl = useOrgPhoto(organizationId);

  return (
    <div className={clsx(styles.container, className)} onClick={onClick} {...props}>
      {!!profileImg ? <img src={profileImg} alt="avatar" className={styles.profileImage} /> : nameInitials}
      {!!organizationImageUrl && <img src={organizationImageUrl} alt="avatar" className={styles.orgImage} />}
    </div>
  );
}
